import React from "react";

const ZONES = [
  { name: "Tidal Study Station", note: "River edge · water and creature notes kept here." },
  { name: "Pantry & Reception", note: "Duar — doorway. Where the morning menu is written." },
  { name: "Twin Suites", note: "Front of the property. Paired rooms, utilitarian and unfussy." },
  { name: "Admin Office", note: "Small. Behind the pantry. Rarely used by guests." },
  { name: "Shallow Pump", note: "Freshwater draw for beds and the kitchen." },
  { name: "Water Tank", note: "Central. Marks the middle of the plot." },
  { name: "Jungle Villas", note: "Raised deck across the gawa, held in golpata and native trees." },
  { name: "Pond W / E", note: "West Gawa and East Gawa — freshwater cultivation." },
  { name: "Vegetable Beds", note: "Rows facing the sun. Turned by hand." },
  { name: "Chicken Coop", note: "Muscovy ducks · Murgi Bari nearby." },
];

export default function Farm() {
  return (
    <div data-testid="page-farm">
      <section style={{ background: "var(--salt-white)" }}>
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-24 md:pt-32 pb-10 md:pb-16">
          <div
            className="italic-display mb-3"
            style={{ fontSize: "clamp(18px, 2vw, 24px)", color: "var(--sundari-gold)", opacity: 0.9 }}
            data-testid="page-bengali"
          >
            খামার
          </div>
          <div className="eyebrow" style={{ color: "var(--delta-clay)" }}>The Farm</div>
          <h1 className="italic-display mt-6" style={{ fontSize: "clamp(48px, 7.5vw, 100px)", lineHeight: 1 }}>
            The land is the menu.
          </h1>
          <p className="mt-8 max-w-[720px]" style={{ fontSize: "17px", lineHeight: 1.75 }}>
            Guests don&rsquo;t observe a farm — they inhabit it. Brackish water crab ponds,
            freshwater fish cultivation, golpata palms, banana groves, tomato fields, and a mangrove
            nursery form the living landscape of each stay.
          </p>
        </div>
      </section>

      <section style={{ background: "var(--bamboo-cream)" }}>
        <div className="max-w-[1200px] mx-auto px-6 md:px-10 py-20 md:py-28">
          <div className="grid md:grid-cols-12 gap-10 md:gap-16 items-start">
            <div className="md:col-span-5">
              <div className="eyebrow" style={{ color: "var(--delta-clay)" }}>The Shape of It</div>
              <h2 className="italic-display mt-5" style={{ fontSize: "clamp(34px, 4.4vw, 52px)", lineHeight: 1.02 }}>
                A living landscape you inhabit, not one you observe.
              </h2>
              <hr className="divider-gold mt-8" />
              <p className="mt-8" style={{ fontSize: "15.5px", lineHeight: 1.75 }}>
                Two ponds hold the freshwater. A brackish channel feeds the crab bhaer. Between
                them, the beds are turned by hand. The cottages sit lightly at either edge.
              </p>
            </div>
            <div className="md:col-span-7 hair-t pt-8 space-y-4" style={{ fontSize: "15px", lineHeight: 1.8 }}>
              <p>
                Read down the zones. Each one is a small working piece of the delta — the pantry
                that reads the morning, the shallow pump that drinks from the freshwater lens, the
                tidal study station where the day&rsquo;s water notes are kept.
              </p>
              <p>
                Nothing here is a set. The tomato field is still a tomato field when no one is
                looking.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Zone list */}
      <section style={{ background: "var(--salt-white)" }}>
        <div className="max-w-[1200px] mx-auto px-6 md:px-10 py-20 md:py-28">
          <div className="eyebrow mb-8" style={{ color: "var(--delta-clay)" }}>Zones</div>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-14 gap-y-6">
            {ZONES.map((z, i) => (
              <li
                key={z.name}
                className="hair-b pb-5 flex items-start gap-4"
                data-testid={`zone-${z.name.toLowerCase().replace(/[\s\/]+/g, "-")}`}
              >
                <span className="label-track pt-1" style={{ color: "var(--sundari-gold)", minWidth: 34 }}>
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div>
                  <div className="italic-display" style={{ fontSize: "24px" }}>{z.name}</div>
                  <div className="mt-1 text-[13.5px]" style={{ color: "var(--mangrove-night)", opacity: 0.78 }}>
                    {z.note}
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* Philosophy quote */}
      <section style={{ background: "var(--mangrove-night)", color: "var(--bamboo-cream)" }}>
        <div className="max-w-[1000px] mx-auto px-6 md:px-10 py-24 md:py-36 text-center">
          <div className="eyebrow" style={{ color: "var(--sundari-gold)" }}>Farming Philosophy</div>
          <blockquote
            className="italic-display mt-8"
            style={{ fontSize: "clamp(30px, 4vw, 52px)", lineHeight: 1.2 }}
            data-testid="farm-pullquote"
          >
            &ldquo;Our kitchen has no supplier list. It has a morning walk.&rdquo;
          </blockquote>
          <div className="mx-auto mt-10 divider-gold" />
        </div>
      </section>
    </div>
  );
}
